import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DangerousGoodsUnNumber } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { DangerousGoodsUnNumberService } from '../../services/dangerous-goods-un-number.service';

@Component({
  selector: 'app-dangerous-goods-un-number-dropdown',
  templateUrl: './dangerous-goods-un-number-dropdown.component.html',
  providers: [DangerousGoodsUnNumberService],
  imports: [CommonModule]
})
export class DangerousGoodsUnNumberDropdownComponent extends GenericBaseModelDropDown<DangerousGoodsUnNumber> {

  constructor(private service: DangerousGoodsUnNumberService) {
    super(service, "DangerousGoodsUnNumber");
  }

}
